// removed by extract-text-webpack-plugin
module.exports = {"theme":"#E50009"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/variables.scss
// module id = VbAD
// module chunks = 19